export interface DigestProvider {
  digest(algorithm: string, data: BufferSource): Promise<ArrayBuffer>;
}

export function bytesToHex(bytes: Uint8Array): string {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join(
    "",
  );
}

export async function hashSourceText(
  source: string,
  digestProvider: DigestProvider = globalThis.crypto.subtle,
): Promise<string> {
  const bytes = new TextEncoder().encode(source);
  const digest = await digestProvider.digest("SHA-256", bytes);
  return bytesToHex(new Uint8Array(digest));
}
